<script>
import _ from "underscore";

import api from "@/helpers/api";
import auth from "@/helpers/auth";

const apiVersion = 'v1';
const source = 'team';

export default {
  props: {
    settings: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      state: "normal",
      resource: {},
      fields: [],
      errors: {}
    };
  },

  watch: {
    settings() {
      this.setResource();
    }
  },

  created() {
    this.setResource();
  },

  methods: {
    setResource() {
      _.each(this.fields, (f) => (this.resource[f] = this.settings[f]));
    },

    submit() {
      if (this.state !== "normal") return;
      this.state = "loading";

      api
        .instance()
        .put(`/${apiVersion}/${source}`, { team_id: auth.teamId(), settings: this.resource })
        .then((resp) => {
          this.state = "done";
          this.errors = {};
          setTimeout(() => {
            this.state = "normal";
          }, 2000);
        })
        .catch((err) => {
          this.state = "normal";
          console.error("Update settings error:", err);
          this.errors = { ...err?.response?.data?.errors?.settings };
        });
    }
  }
};
</script>
